export const $white = '#FFFFFF';
export const $primary = '#F25858';
export const $primaryText = '#04080F';
